import { sendGet } from './dataUtilities';
import env from '../env';

const PUT_VALIDATE_TOKEN_ENDPOINT = '/api/teams/invite-code';

export const validateInviteCode = (inviteCode: string) => sendGet(
  `${env.aceApiBaseUrl + PUT_VALIDATE_TOKEN_ENDPOINT}/${inviteCode}`, {},
);

export default validateInviteCode;
